import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import ModalCustom from '../../../modal-custom'
import { Button, Col, Form } from 'react-bootstrap'
import LabelCustom from '../../../label-custom'
import { createFactionsAPI } from '../../../../services/factions'
import Error_false from '../../../error/error-false'
import Swal from 'sweetalert2'
import SwalCustom from '../../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../../Constants'

const schema = yup
  .object({
    faction: yup.string().required('Please, Input character of Division'),
    factionEn: yup.string().required('Please, Input Division for English'),
    factionTh: yup.string().required('Please, Input Division for Thai')
  })
  .required()

export default function AddDepartment({
  param,
  setIsSave,
  showCreate,
  isSave,
  fnGetData,
  setShowCreate,
  handleKeyDownTH,
  handleKeyDownEN,
  handleKeyDownNum
}) {
  const {
    control,
    setError,
    handleSubmit,

    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  const onSubmit = (d) => {
    const body = { ...param, ...d, larkEnable: d.larkEnable ?? false }

    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to create new?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        createDepartment(body)
      }
    })
  }

  const createDepartment = async (body) => {
    const data = await createFactionsAPI(body)
    if (!data) {
      setIsSave(false)
      return
    }

    if (data.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        setShowCreate(false)
        fnGetData()
        fnReset()
        Swal.close()
      })
    } else {
      Error_false(data)
    }
    setIsSave(false)
    fnReset()
  }

  const fnReset = () => {
    setError('faction', false)
    setError('faction_en', false)
    setError('faction_th', false)
  }

  const handleClose = () => {
    setShowCreate(false)
    fnReset()
  }
  return (
    <ModalCustom width={500} open={showCreate} onCancel={handleClose}>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-3 row"
        style={{ rowGap: '13px' }}
      >
        <label className="text-primary">Add Division</label>

        <Col md={12}>
          <LabelCustom text={'Division'} />
          <Controller
            name={'faction'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                maxLength={2}
                value={value}
                onChange={onChange}
                onKeyDown={handleKeyDownEN}
              />
            )}
          />
          {errors.faction?.message && (
            <label className="small text-danger">
              {errors.faction.message}
            </label>
          )}
        </Col>

        <Col md={12}>
          <LabelCustom text={'Division EN'} />
          <Controller
            name={'factionEn'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                maxLength={100}
                value={value}
                onChange={onChange}
                // onKeyDown={handleKeyDownEN}
              />
            )}
          />
          {errors.factionEn?.message && (
            <label className="small text-danger">
              {errors.factionEn.message}
            </label>
          )}
        </Col>

        <Col md={12}>
          <LabelCustom text={'Division TH'} />
          <Controller
            name={'factionTh'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                maxLength={100}
                value={value}
                onChange={onChange}
                // onKeyDown={handleKeyDownTH}
              />
            )}
          />
          {errors.factionTh?.message && (
            <label className="small text-danger">
              {errors.factionTh.message}
            </label>
          )}
        </Col>

        <Col md={12}>
          <Controller
            name={'larkEnable'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Group
                className="mb-3"
                controlId="formBasicCheckbox"
                value={value}
                onChange={onChange}
              >
                <Form.Check
                  checked={value}
                  type="checkbox"
                  label="Lark Enable"
                />
              </Form.Group>
            )}
          />
        </Col>

        <Col xl={12} className="text-center">
          <Button className="px-4 " disabled={isSave} type="submit">
            {isSave ? 'Saving...' : 'Save'}
          </Button>
          <Button
            className="px-4 text-primary me-2"
            variant="light"
            type="button"
            disabled={isSave}
            onClick={handleClose}
          >
            Cancel
          </Button>
        </Col>
      </Form>
    </ModalCustom>
  )
}
